import { useSearch } from "@tanstack/react-router";
import { ResetPasswordForm } from "../components/reset-password-form";

export default function ResetPasswordPage() {
  const search = useSearch({ from: "/(auth)/__auth/reset-password" });

  return (
    <div className="h-full w-full flex flex-col gap-7 items-center ">
      <div className="space-y-2">
        <h1 className="text-xl font-semibold">
          Reset Password
        </h1>
        <h2 className="text-sm text-neutral-600">
          Enter your new password
        </h2>
      </div>
      <ResetPasswordForm token={search.token} />
    </div>
  );
}
